import { createSlice } from '@reduxjs/toolkit';
import { PERMISSIONS } from 'consts';

import {
  serviceGetRoles,
  serviceGetRole,
  servicePutRole,
  serviceDeleteRole,
  servicePostRole,
} from 'utils';

const initialState = {
  data: null,
  permissionKeys: null,
  isLoaded: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  success: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  error: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
}

const RoleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {

    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpRole() {
      return initialState;
    },

    cleanUpMessageRole(state) {
      return {
        ...state,
        data: null,
        permissionKeys: null,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },

    setPermissionKeys(state, keys) {
      return {
        ...state,
        permissionKeys: keys.payload
      }
    }
  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpRole,
  cleanUpMessageRole,
  setPermissionKeys
} = RoleSlice.actions;

const fetchGetRole = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetRole(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchGetRoles = () => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetRoles()
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPostRole = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostRole(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'post'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'post'})));
  };
};

const fetchPutRole = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutRole(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchDeleteRole = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('delete'));
    serviceDeleteRole(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'delete'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'delete'})));
  };
};

const getPermissionsKeys = () => {
  let permissionsKeys = [];
  let view = '';
  PERMISSIONS.forEach( p => {
    view = p.view;
    Object.keys(p).forEach(keyPermissionsView => {
      if (keyPermissionsView !== 'view') {
        permissionsKeys.push(`${view}-${keyPermissionsView}`)
      }
    })
  });
  return (dispatch) => {
    dispatch(setPermissionKeys (permissionsKeys))
  }
}

export {
  fetchGetRole,
  fetchGetRoles,
  fetchPostRole,
  fetchPutRole,
  fetchDeleteRole,
  getPermissionsKeys,
  cleanUpRole,
  cleanUpMessageRole
};


export default RoleSlice.reducer;